module.exports = {
      id: "pen-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#pen",
      toString: function () {
        return this.url;
      }
    }